import { Controller } from "@hotwired/stimulus"

console.log("source_picker_controller file loaded")

export default class extends Controller {
  static targets = ["query", "results", "select", "newForm"]


  connect() {
    // console.log("source-picker connected", this.element)
  }

  pick(event) {
    const id = event.target.value
    if (!id) return
    const title = event.target.options[event.target.selectedIndex]?.textContent || `Source #${id}`
    this._setSelected(id, title)
    event.target.selectedIndex = 0
  }

  autocomplete() {
    if (!this.hasQueryTarget || !this.hasResultsTarget) return
    const q = this.queryTarget.value.trim()
    clearTimeout(this._t)
    if (q.length < 2) { this.resultsTarget.innerHTML = ""; return }
    this._t = setTimeout(async () => {
      const res = await fetch(`/sources/autocomplete?q=${encodeURIComponent(q)}`, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const items = await res.json()
      this.resultsTarget.innerHTML = items.map(i =>
        `<li class="list-group-item" data-id="${i.id}" data-title="${this._escape(i.title)}">${this._escape(i.title)}</li>`
      ).join("")
      this.resultsTarget.querySelectorAll("li").forEach(li => {
        li.addEventListener("click", () => {
          this._setSelected(li.dataset.id, li.dataset.title)
          this.resultsTarget.innerHTML = ""
          if (this.hasQueryTarget) this.queryTarget.value = li.dataset.title
          if (this.hasNewFormTarget) this.newFormTarget.style.display = "none"
        })
      })
    }, 200)
  }

  // toggleNewForm(event) {
  //   event?.preventDefault()
  //   event?.stopImmediatePropagation()

  //   const container = event.currentTarget.closest(".mt-3")
  //   if (!container) return

  //   const el = container.querySelector('[data-source-picker-target="newForm"]')
  //   if (!el) return

  //   el.style.display = (el.style.display === "none" || !el.style.display) ? "block" : "none"

  //   if (this.hasSelectTarget && el.style.display === "block") {
  //     this.selectTarget.value = ""
  //   }
  // }

  toggleNewForm(event) {
  event?.preventDefault()
  event?.stopPropagation()

  if (!this.hasNewFormTarget) return

  const isHidden =
    this.newFormTarget.style.display === "none" ||
    this.newFormTarget.style.display === ""

  this.newFormTarget.style.display = isHidden ? "block" : "none"

  if (this.hasSelectTarget && isHidden) {
    this.selectTarget.value = ""
  }
}

  clearSelectIfTyped() {
    if (this.hasSelectTarget) {
      this.selectTarget.innerHTML = '<option value="" selected></option>'
    }
  }

  _setSelected(id, title) {
    if (!this.hasSelectTarget) return
    this.selectTarget.innerHTML = `<option value="${id}" selected>${this._escape(title)}</option>`
  }

  _escape(s) {
    return (s || "").replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))
  }
}
